var _path, _circle, _circle2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDevOpsKnowBg(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1440,
    height: 529,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#387",
    fillOpacity: 0.1,
    d: "M1228 3h41v41h-41z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 683,
    cy: 330,
    r: 19.5,
    stroke: "#387",
    strokeOpacity: 0.07,
    strokeWidth: 7
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 1315,
    cy: 489,
    r: 10.5,
    stroke: "#387",
    strokeOpacity: 0.07,
    strokeWidth: 7
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNDQwIiBoZWlnaHQ9IjUyOSIgdmlld0JveD0iMCAwIDE0NDAgNTI5IiBmaWxsPSJub25lIj4KICAgIDxyZWN0IHg9IjEyMjgiIHk9IjMiIHdpZHRoPSI0MSIgaGVpZ2h0PSI0MSIgZmlsbD0iIzMzODg3NyIgZmlsbC1vcGFjaXR5PSIwLjEiLz4KICAgIDxjaXJjbGUgY3g9IjY4MyIgY3k9IjMzMCIgcj0iMTkuNSIgc3Ryb2tlPSIjMzM4ODc3IiBzdHJva2Utb3BhY2l0eT0iMC4wNyIgc3Ryb2tlLXdpZHRoPSI3Ii8+CiAgICA8Y2lyY2xlIGN4PSIxMzE1IiBjeT0iNDg5IiByPSIxMC41IiBzdHJva2U9IiMzMzg4NzciIHN0cm9rZS1vcGFjaXR5PSIwLjA3IiBzdHJva2Utd2lkdGg9IjciLz4KPC9zdmc+";
export { SvgDevOpsKnowBg as ReactComponent };